import React, { useEffect, useRef, useState } from "react";
import PaginationComponent from "../../../../biblio/Pagination/PaginationComponent";
import { Col, ConfigProvider, Row } from "antd";
import Selects from "../../../../biblio/Selects/Selects";
import PrimaryButton from "../../../../biblio/Buttons/PrimaryButton";
import DotsLoader from "../../../../biblio/Loader/DotsLoader";
import ar_EG from "antd/lib/locale/ar_EG";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../apis/store";
import {
  getDateRange,
  scroll,
} from "../../../../components/utils/utils";
import { CancelSponsorShipList } from "./CancelSponsorShipList";
import CancelSponsorship from "./CancelSponsorship";
import {
  getCancelReasons,
  getSponsorshipCancel,
} from "../../../../apis/actions/sponsorship.actions";
import CustomConfigProvider from "../../ProfileHeader";
const CancelSponserShipOverview = () => {
  const dispatch = useDispatch<AppDispatch>();
  const currentRef = useRef<HTMLDivElement>(null);
  const [selectedFilter, setSelectedFilter] = useState<any>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [state, setState] = useState({
    year: "",
    month: "",
  });

  const { cancelReasons, sponsorshipCancel, loading, TotalCancels } =
    useSelector((state: RootState) => state?.sponsorship);
  const OtpId = useSelector((state: RootState) => state?.recipient?.OtpId);
  useEffect(() => {
    const { date_from, date_to } = getDateRange(state.year, state.month);

    dispatch(
      getSponsorshipCancel({
        sponsor_id: OtpId,
        limit: itemPerPage,
        page: currentPage,
        cancel_reason_id: selectedFilter,
        date_from: date_from,
        date_to: date_to,
      })
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, state, currentPage, selectedFilter]);

  useEffect(() => {
    dispatch(getCancelReasons());
  }, [dispatch]);
  const updateActive = (nb: number) => {
    setCurrentPage(nb);
    scroll(currentRef);
  };
  const itemPerPage = 4;
  const handleSelectChange = (value: any) => {
    if (value) {
      setSelectedFilter(value.value);
    } else {
      setSelectedFilter(null);
    }
    setCurrentPage(1);
  };
  return (
    <>
      <CustomConfigProvider
        title="إلغاء كفالاتي"
        withdateFilter={true}
        filterState={state}
        setState={(values) => setState(values)}
      >
        {" "}
        <Selects
          options={cancelReasons}
          selectPlaceholder="سبب الإلغاء"
          onChange={handleSelectChange}
          allowClear={true}
          className="takaful--service-select takaful--request-select"
          popupClassName="takaful--service-select-dropdown"
        />
      </CustomConfigProvider>
      <ConfigProvider locale={ar_EG} direction="rtl">
        <Row justify={"space-between"} className="takaful--request-col-space">
          <Col
            xxl={{ span: 4, order: 1 }}
            xl={{ span: 4, order: 1 }}
            lg={{ span: 4, order: 1 }}
            md={{ span: 4, order: 1 }}
            sm={{ span: 11, order: 2 }}
            xs={{ span: 11, order: 2 }}
          >
            <PrimaryButton
              onClick={() => setIsModalVisible(true)}
              title=" إنشاء طلب إلغاء"
              className="takaful--add-request-btn"
            />
          </Col>
        </Row>
      </ConfigProvider>
      {loading ? (
        <div
          className="takaful--loading-projects-cases"
          style={{ marginTop: "5rem" }}
        >
          <p className="takaful--no-project-message"> جارٍ التحميل</p>
          <DotsLoader />
        </div>
      ) : sponsorshipCancel?.length === 0 &&
        !selectedFilter &&
        // eslint-disable-next-line eqeqeq
        state.year == "" ? (
        <p className="takaful--no-services" style={{ marginTop: "5rem" }}>
          لا توجد كفالات
        </p>
      ) : sponsorshipCancel?.length === 0 &&
        (selectedFilter || state.year !== "") ? (
        <p className="takaful--no-services" style={{ marginTop: "5rem" }}>
          لا يوجد طلبات إلغاء تتوافق مع البحث الذي قمت به
        </p>
      ) : (
        <>
          <Row gutter={[16, 48]} justify={"space-around"} ref={currentRef}>
            <CancelSponsorShipList sponsorship={sponsorshipCancel} />
          </Row>
          <div className="takaful--pagination-container">
            {sponsorshipCancel &&
              Math.ceil(TotalCancels) * itemPerPage > itemPerPage && (
                <PaginationComponent
                  active={currentPage}
                  total={Math.ceil(TotalCancels) * itemPerPage}
                  itemPerPage={itemPerPage}
                  scroll={() => scroll(currentRef)}
                  setActive={(nb) => updateActive(nb)}
                />
              )}
          </div>
        </>
      )}
      <CancelSponsorship
        cancelReasons={cancelReasons}
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
      />
    </>
  );
};

export default CancelSponserShipOverview;
